import { t } from "i18next";
import React, { useState } from "react";
import { UseFormRegister, UseFormWatch } from "react-hook-form";
import { changePassword } from "../../../../../../../../../common/types/Auth/changePassword";

import "./ConfirmPassword.scss";

interface IConfirmPassword {
  register: UseFormRegister<changePassword>;
  watch: UseFormWatch<changePassword>;
}

const ConfirmPassword = ({ register, watch }: IConfirmPassword) => {
  const [inputOpen, setInputOpen] = useState(true);
  const password = watch("password");
  const confirmPassword = watch("password_confirmation");
  const validateCurrentPassword = () => {
    if (confirmPassword === password) {
      return true;
    }
  };
  const onFocus = () => {
    setInputOpen(true);
  };
  const onBlur = () => {
    if (confirmPassword.length > 0) {
      setInputOpen(true);
    } else {
      setInputOpen(false);
    }
  };
  return (
    <div className="u-i-p-control-item-holder-bc">
      <div
        className={`form-control-bc default has-icon ${
          inputOpen ? "focused" : ""
        }`}
      >
        <label className="form-control-label-bc inputs">
          <input
            type="password"
            className="form-control-input-bc"
            autoComplete="current-password"
            {...register("password_confirmation", {
              required: true,
              validate: validateCurrentPassword,
            })}
            onFocus={onFocus}
            onBlur={onBlur}
          />
          <i className="form-control-input-stroke-bc" />
          <span className="form-control-title-bc ellipsis">
            {t("admin.ChangePassword")}
          </span>
        </label>
      </div>
    </div>
  );
};

export { ConfirmPassword };
